import { normalizeSource } from './source';
import {
  HashtagSources,
  ProfessionWithHashtagsType,
  SearchedHashtag,
} from './../../types/models';
import {
  DepartmentsApiResponse,
  HashtagSourcesApiResponse,
  SearchedHashtagApiResponse,
} from 'api/api.types';
import { Normalizer } from './types';
import { normalizeUserData } from './profile';

export const normalizeHashtagSources: Normalizer<
  HashtagSourcesApiResponse,
  HashtagSources
> = hashtag => {
  return {
    hashtag: hashtag.hashtag,
    meta: hashtag.meta,
    objects: hashtag.objects.map(src => normalizeSource(src)),
    totalIdeas: hashtag.total_ideas,
    relatedTopics: hashtag.related_hashtags,
    topStashers:
      hashtag.top_stashers?.map(apiUser => normalizeUserData(apiUser)) ?? [],
    totalRelatedTopics: hashtag.total_related_hashtags,
    totalTopStashers: hashtag.total_top_stashers,
  };
};

export const normalizeSearchedHashtag: Normalizer<
  SearchedHashtagApiResponse,
  SearchedHashtag
> = searchedHashtag => {
  return {
    sources: searchedHashtag.articles?.map(article => normalizeSource(article)),
    name: searchedHashtag.name,
    totalIdeas: searchedHashtag.total_ideas,
  };
};

export const normalizeProfessionsWithHashtagsApiResponse: Normalizer<
  DepartmentsApiResponse,
  ProfessionWithHashtagsType[]
> = response => {
  const finalArray: ProfessionWithHashtagsType[] = [];

  response.departments.forEach(department => {
    finalArray.push({
      name: department.name,
      workHashtags: department.work_hashtags,
      personalHashtags: department.personal_hashtags,
      trendingHashtags: department.trending_hashtags,
    });
  });

  return finalArray;
};
